import {FC} from 'react';

import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import ChevronRight from 'assets/icons/chevronRight';
import {useExpressDimensionLimit} from 'hooks/useExpressDimensionLimit';
import {useExpressWeightLimit} from 'hooks/useExpressWeightLimit';

import {
  WeightCapacityContainer,
  WeightCapacityTop,
  WeightCapacityBottom,
  StyledProgressBox,
  StyledProgressBar
} from './styles';

interface BasketWeightCapacityComponentProps {
  fullWidth?: boolean;
  onClick?: () => void;
}

export const BasketWeightCapacityComponent: FC<BasketWeightCapacityComponentProps> = ({fullWidth, onClick}) => {
  const {capacityPercent: weightCapacityPercent, totalWeight, threshold: weightThreshold} = useExpressWeightLimit();
  const {
    percentage: dimensionCapacityPercent,
    totalDimension,
    threshold: dimensionThreshold
  } = useExpressDimensionLimit();
  const isCapacityPercentageHigher = weightCapacityPercent > dimensionCapacityPercent;

  const {t} = useTranslation();
  return (
    <WeightCapacityContainer fullWidth={fullWidth} onClick={onClick}>
      <WeightCapacityTop>
        <Typography fontSize={14} fontWeight={600}>
          {t('express.title.basketCapacity')}
        </Typography>
        {fullWidth ? <></> : <ChevronRight width={16} height={16} fillColor="#D84018"></ChevronRight>}
      </WeightCapacityTop>
      {isCapacityPercentageHigher ? (
        <WeightCapacityBottom>
          <StyledProgressBox>
            <StyledProgressBar variant="determinate" value={weightCapacityPercent} />
          </StyledProgressBox>
          <Typography fontSize={12} fontWeight={400} alignSelf="center">
            {t('express.message.basketWeight', {weight: totalWeight, threshold: weightThreshold})}
          </Typography>
        </WeightCapacityBottom>
      ) : (
        <WeightCapacityBottom>
          <StyledProgressBox>
            <StyledProgressBar variant="determinate" value={dimensionCapacityPercent} />
          </StyledProgressBox>
          <Typography fontSize={12} fontWeight={400} alignSelf="center">
            {t('express.message.basketDimension', {dimension: totalDimension, threshold: dimensionThreshold})}
          </Typography>
        </WeightCapacityBottom>
      )}
    </WeightCapacityContainer>
  );
};
